import type {SVGProps} from 'react'
const DocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.1992 4L19.1992 20C19.1992 20.5523 18.7515 21 18.1992 21L5.79922 21C5.24693 21 4.79922 20.5523 4.79922 20L4.79922 12L4.79922 4C4.79922 3.44771 5.24693 3 5.79922 3L18.1992 3C18.7515 3 19.1992 3.44772 19.1992 4Z"
      stroke="#2D2E2C"
      style={{
        stroke: '#2D2E2C',
        strokeOpacity: 1,
      }}
    />
    <line
      x1={7.19922}
      y1={7.90039}
      x2={13.1992}
      y2={7.90039}
      stroke="#2D2E2C"
      style={{
        stroke: '#2D2E2C',
        strokeOpacity: 1,
      }}
    />
    <line
      x1={14.4004}
      y1={7.90039}
      x2={16.8004}
      y2={7.90039}
      stroke="#2D2E2C"
      style={{
        stroke: '#2D2E2C',
        strokeOpacity: 1,
      }}
    />
    <line
      x1={7.19922}
      y1={10.3008}
      x2={13.1992}
      y2={10.3008}
      stroke="#2D2E2C"
      style={{
        stroke: '#2D2E2C',
        strokeOpacity: 1,
      }}
    />
    <line
      x1={14.4004}
      y1={10.3008}
      x2={16.8004}
      y2={10.3008}
      stroke="#2D2E2C"
      style={{
        stroke: '#2D2E2C',
        strokeOpacity: 1,
      }}
    />
    <line
      x1={7.19922}
      y1={12.6992}
      x2={13.1992}
      y2={12.6992}
      stroke="#2D2E2C"
      style={{
        stroke: '#2D2E2C',
        strokeOpacity: 1,
      }}
    />
    <line
      x1={14.4004}
      y1={12.6992}
      x2={16.8004}
      y2={12.6992}
      stroke="#2D2E2C"
      style={{
        stroke: '#2D2E2C',
        strokeOpacity: 1,
      }}
    />
    <line
      x1={14.4004}
      y1={17.5}
      x2={16.8004}
      y2={17.5}
      stroke="#2D2E2C"
      style={{
        stroke: '#2D2E2C',
        strokeOpacity: 1,
      }}
    />
    <path
      d="M18.5992 4.20039C18.5992 3.86902 18.3306 3.60039 17.9992 3.60039H5.99922C5.66785 3.60039 5.39922 3.86902 5.39922 4.20039V19.8004C5.39922 20.1318 5.66785 20.4004 5.99922 20.4004H17.9992C18.3306 20.4004 18.5992 20.1318 18.5992 19.8004V4.20039ZM16.7992 16.8004V18.0004H14.3992V16.8004H16.7992ZM13.1992 12.0004V13.2004H7.19922V12.0004H13.1992ZM16.7992 12.0004V13.2004H14.3992V12.0004H16.7992ZM13.1992 9.60039V10.8004H7.19922V9.60039H13.1992ZM16.7992 9.60039V10.8004H14.3992V9.60039H16.7992ZM13.1992 7.20039V8.40039H7.19922V7.20039H13.1992ZM16.7992 7.20039V8.40039H14.3992V7.20039H16.7992ZM19.7992 19.8004L19.7898 19.9844C19.7038 20.8316 19.0304 21.505 18.1832 21.591L17.9992 21.6004H5.99922C5.00511 21.6004 4.19922 20.7945 4.19922 19.8004V4.20039C4.19922 3.20628 5.00511 2.40039 5.99922 2.40039H17.9992C18.9933 2.40039 19.7992 3.20628 19.7992 4.20039V19.8004Z"
      fill="#2D2E2C"
      style={{
        fill: '#2D2E2C',
        fillOpacity: 1,
      }}
    />
  </svg>
)
export {DocumentIcon}
